<style src="./RegisterPark.scss" lang="scss"></style>
<template>
  <div class="wrapper wrapper-content animated fadeIn">
    <div class="row">
      <div class="col-lg-5">
        <div class="ibox float-e-margins">
          <div class="ibox-content mailbox-content">
            <form v-on:submit.prevent="createPark">
              <h2>Cadastro</h2>
              
              <div class="space-25"></div>
              <div class="row">
                <div class="form-group col-lg-12">
                  <div class="form-group">
                    <label>Nome</label>
                    <input
                      type="text"
                      placeholder="CENTRO - ALAMEDA DOS PASSOS"
                      class="form-control"
                      v-model="registerForm.form.parkName"
                    />
                  </div>
                  <!-- <div class="form-group">
                    <label>Nome Interno</label>
                    <input
                      type="text"
                      placeholder="Rua 2"
                      class="form-control"
                      v-model="registerForm.form.internalName"
                    />
                  </div> -->
                  <div class="form-group">
                    <label>Código Interno</label>
                    <input
                      type="text"
                      placeholder="2265"
                      class="form-control"
                      v-model="registerForm.form.internalCode"
                    />
                  </div>
                </div>
              </div>

              <div class="space-25"></div>
              <h3>Endereço</h3>
              <div class="row">
                <div class="form-group col-lg-12">
                  <div class="form-group">
                    <label>Rua/Avenida</label>
                    <input
                      type="text"
                      placeholder="Rua Almirante Gonçalves"
                      class="form-control"
                      v-model="registerForm.form.street"
                    />
                  </div>
                <!-- </div> -->
                <!-- <div class="form-group col-lg-12"> -->
                  <div class="form-group">
                    <label>Bairro</label>
                    <input
                      type="text"
                      placeholder="Cascatinha"
                      class="form-control"
                      v-model="registerForm.form.neighborhood"
                    />
                  </div>
                <!-- </div> -->
                <!-- <div class="form-group col-lg-12"> -->
                  <div class="form-group">
                    <label>UF</label>
                    <input
                      type="text"
                      placeholder="SP"
                      class="form-control"
                      v-model="registerForm.form.uf"
                    />
                  </div>
                </div>
              </div>
              
              <div class="space-25"></div>
              <h3>Definição das Vagas</h3>
              <div class="row">
                <div class="form-group col-lg-6">
                  <label>Quantidade de vagas</label>
                  <input
                    type="number"
                    placeholder="5"
                    class="form-control"
                    v-model="registerForm.form.parkingSpaceCount"
                  />
                </div>
                <div class="form-group col-lg-6">
                  <label>Tolerância de continuidade</label>
                  <input
                    type="number"
                    placeholder="15"
                    class="form-control"
                    v-model="registerForm.form.continuousTolerance"
                  />
                </div>
              </div>
              <div class="form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-model="registerForm.form.disabled"
                />
                <label class="form-check-label checkboxlabel">Desativado</label>
              </div>
              <h4>Localização</h4>
              <div class="row">
                <div class="form-group col-lg-6">
                  <label>Latitude</label>

                  <input
                    type="text"
                    placeholder="-22"
                    class="form-control"
                    v-model="registerForm.form.pathPolygon.lat"
                  />
                </div>
                <div class="form-group col-lg-6">
                  <label>Longitude</label>
                  <input
                    type="text"
                    placeholder="-42"
                    class="form-control"
                    v-model="registerForm.form.pathPolygon.lng"
                  />
                </div>
              </div>

              <h3>Localização para busca</h3>
              <div>
                <table class="table table-hover table-mail">
                  <thead class="table-head">
                    <tr>
                      <th>Latitude</th>
                      <th>Longitude</th>
                      <th></th>
                    </tr>
                  </thead>

                  <tbody class="table-list">
                    <tr
                      v-for="(coords, listIdx) in registerForm.form
                        .geoReference"
                      :key="listIdx"
                    >
                      <td>{{ coords.lat }}</td>
                      <td>{{ coords.lng }}</td>

                      <td>
                        <button
                          type="button"
                          class="btn btn-outline"
                          title="Remover"
                          @click="removeCord(listIdx)"
                        >
                          <i class="fa fa-trash text-danger"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <form v-on:submit.prevent="addCoords">
                  <div class="row">
                    <div class="form-group col-lg-6">
                      <label>Latitude</label>
                      <input
                        type="text"
                        placeholder="-22"
                        class="form-control"
                        v-model="geoReferenceForm.lat"
                      />
                    </div>
                    <div class="form-group col-lg-6">
                      <label>Longitude</label>
                      <input
                        type="text"
                        placeholder="-45"
                        class="form-control"
                        v-model="geoReferenceForm.lng"
                      />
                    </div>
                  </div>
                  <button
                    class="btn btn-success compose-mail"
                    href="mail_compose.html"
                  >
                    <i class="fa fa-plus"></i>
                    Adicionar Localização
                  </button>
                </form>
              </div>
              <br />
              <h3>Vagas</h3>
              <div>
                <table class="table table-hover table-mail">
                  <thead class="table-head">
                    <tr>
                      <th>Nome</th>
                      <th>Tolerância</th>
                      <th>lat</th>
                      <th>lng</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>

                  <tbody class="table-list">
                    <tr
                      v-for="(spot, listIdx) in registerForm.form.spots"
                      :key="listIdx"
                    >
                      <td>{{ spot.name }}</td>
                      <td>{{ spot.continuousTolerance }}</td>
                      <td>{{ spot.location && spot.location.lat }}</td>
                      <td>{{ spot.location && spot.location.lng }}</td>

                      <td>
                        <button
                          type="button"
                          class="btn btn-outline"
                          title="Remover"
                          @click="removeSpot(listIdx)"
                        >
                          <i class="fa fa-trash text-danger"></i>
                        </button>
                      </td>
                      <td>
                        <button
                          type="button"
                          class="btn btn-outline"
                          title="Inabilitar funcionário"
                          @click="enterEditSpotMode(spot, listIdx)"
                        >
                          <i class="fa fa-edit text-success"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <form v-on:submit.prevent="addSpot">
                  <div class="row">
                    <div class="form-group col-lg-6">
                      <label>Nome</label>
                      <input
                        type="text"
                        placeholder="vaga 1"
                        class="form-control"
                        v-model="spotForm.name"
                      />
                    </div>
                    <div class="form-group col-lg-6">
                      <label>Tolerância</label>
                      <input
                        type="number"
                        placeholder="30"
                        class="form-control"
                        v-model="spotForm.continuousTolerance"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-lg-6">
                      <label>Latitude</label>
                      <input
                        type="text"
                        placeholder="20"
                        class="form-control"
                        v-model="spotForm.location.lat"
                      />
                    </div>
                    <div class="form-group col-lg-6">
                      <label>Longitude</label>
                      <input
                        type="text"
                        placeholder="-30"
                        class="form-control"
                        v-model="spotForm.location.lng"
                      />
                    </div>
                  </div>
                  <button
                    class="btn btn-success compose-mail"
                    href="mail_compose.html"
                    v-if="!spotForm.control.enableEditMode"
                  >
                    <i class="fa fa-plus"></i>
                    Adicionar Vaga
                  </button>
                  <div v-if="spotForm.control.enableEditMode">
                    <button
                      type="button"
                      class="btn btn-outline"
                      href="mail_compose.html"
                      @click="exitEditSpot"
                    >
                      Cancelar
                    </button>

                    <button
                      type="button"
                      class="btn btn-warning pull-right"
                      href="mail_compose.html"
                      @click="saveSpot"
                    >
                      <i class="fa fa-save"></i>
                      Salvar
                    </button>
                  </div>
                </form>
              </div>
              <br /><br />
              <div class="space-25"></div>
              <div class="space-25"></div>
              <button
                class="btn btn-block btn-primary compose-mail"
                href="mail_compose.html"
                :disabled="
                  !permissionCreate ||
                    registerForm.control.createButtonIsDisabled
                "
                v-if="!registerForm.control.editModeId"
              >
                <i class="fa fa-save"></i>
                Criar Estacionamento
              </button>

              <div v-if="registerForm.control.editModeId">
                <button
                  type="button"
                  class="btn btn-outline"
                  href="mail_compose.html"
                  :disabled="registerForm.control.createButtonIsDisabled"
                  @click="disableEditMode"
                >
                  Cancelar
                </button>

                <button
                  type="button"
                  class="btn btn-warning pull-right"
                  href="mail_compose.html"
                  :disabled="
                    registerForm.control.createButtonIsDisabled ||
                      !permissionUpdate
                  "
                  @click="saveEdition"
                >
                  <i class="fa fa-save"></i>
                  Salvar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-lg-7 animated fadeInRight">
        <div class="mail-box-header">
          <h2>Lista de Estacionamentos</h2>

          <form>
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                v-model="searchForm.form.parkName"
              />

              <div class="input-group-btn">
                <button
                  type="button"
                  class="btn btn-sm btn-primary"
                  @click="searchParks"
                  v-if="permissionRead"
                >
                  <i class="fa fa-search"></i>
                  Buscar
                </button>
              </div>
            </div>
          </form>
        </div>
        <div class="mail-box">
          <table class="table table-hover table-mail">
            <thead class="table-head">
              <tr>
                <th>Nome</th>
                <th>Total de vagas</th>
                <th></th>
              </tr>
            </thead>

            <tbody class="table-list">
              <tr v-for="(listItem, listIdx) in parksList.list" :key="listIdx">
                <td>{{ listItem.parkName }}</td>
                <td>{{ listItem.parkingSpaceCount }}</td>

                <td class="list-command">
                  <button
                    class="btn btn-outline"
                    title="Inabilitar funcionário"
                    v-if="permissionUpdate"
                    @click="enterEditMode(listItem)"
                  >
                    <i class="fa fa-edit text-success"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RegisterZones',

  data() {
    return {
      registerForm: {
        form: {
          parkName: '',
          internalName: '',
          internalCode: '',
          parkingSpaceCount: '',
          continuousTolerance: '',
          disabled: false,
          street: '',
          neighborhood: '',
          uf: '',
          pathPolygon: {
            lat: '',
            lng: '',
          },
          geoReference: [],
          spots: [],
        },
        control: {
          editModeId: false,
          createButtonIsDisabled: false,
        },
      },
      spotForm: {
        name: '',
        isFree: true,
        continuousTolerance: '',
        tariffSchedule: null,
        location: {
          lat: '',
          lng: '',
        },
        control: {
          index: '',
          enableEditMode: false,
        },
      },
      geoReferenceForm: {
        index: false,
        editPlan: false,
        lat: '',
        lng: '',
      },
      searchForm: {
        form: {
          parkName: '',
        },
        control: {},
      },
      parksList: {
        originalList: [],
        list: [],
        control: {},
      },
    };
  },
  computed: {
    permissionCreate() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'register-park',
        'CREATE',
      );
    },
    permissionRead() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'register-park',
        'READ',
      );
    },
    permissionUpdate() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'register-park',
        'UPDATE',
      );
    },
    permissionDelete() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'register-park',
        'DELETE',
      );
    },
  },
  watch: {
    'searchForm.form.parkName'() {
      this.searchParks();
    },
  },

  mounted() {
    this.ListParks();
  },
  methods: {
    async ListParks() {
      if (!this.permissionRead) {
        return;
      }
      const parksList = await this.$store.dispatch('PARKING/GetParkList');
      this.parksList.originalList = parksList;
      this.searchParks();
    },
    searchParks() {
      if (!this.permissionRead) {
        return;
      }

      const listFiltered = this.parksList.originalList.filter(item => {
        return (
          item.parkName
            .toUpperCase()
            .indexOf(this.searchForm.form.parkName.toUpperCase()) > -1
        );
      });
      this.parksList.list = listFiltered;
    },
    // coords
    addCoords() {
      const payload = {
        lat: this.geoReferenceForm.lat,
        lng: this.geoReferenceForm.lng,
      };
      this.registerForm.form.geoReference.push(payload);
      this.geoReferenceForm.lat = '';
      this.geoReferenceForm.lng = '';
    },
    removeCord(index) {
      const geo = this.registerForm.form.geoReference;
      geo.splice(index, 1);
      this.registerForm.form.geoReference = geo;
    },
    // spot
    addSpot() {
      const payload = {
        ...this.spotForm,
        control: undefined,
      };
      this.registerForm.form.spots.push(payload);
      this.spotForm.name = '';
      this.spotForm.continuousTolerance = '';
    },
    removeSpot(index) {
      const spots = this.registerForm.form.spots;
      spots.splice(index, 1);
      this.registerForm.form.spots = spots;
    },
    enterEditSpotMode(spot, index) {
      this.spotForm.control.enableEditMode = true;
      this.spotForm.control.index = index;
      this.spotForm.name = spot.name;``
      this.spotForm.tariffSchedule = spot.tariffSchedule;
      if (spot.location) {
        this.spotForm.location = {
          lat: spot.location.lat,
          lng: spot.location.lng,
        };
      }
      this.spotForm.continuousTolerance = spot.continuousTolerance;
    },
    exitEditSpot() {
      this.spotForm.name = '';
      this.spotForm.continuousTolerance = '';
      this.spotForm.control.enableEditMode = false;
      this.spotForm.control.index = '';
      this.spotForm.isFree = true;
      this.spotForm.tariffSchedule = '';
      this.spotForm.location = {
        lat: '',
        lng: '',
      };
    },
    saveSpot() {
      const payload = {
        ...this.spotForm,
        control: undefined,
      };
      const spots = this.registerForm.form.spots;
      const index = this.spotForm.control.index;

      spots[index] = payload;
      this.registerForm.form.spots = spots;
      this.exitEditSpot();
    },

    // Park
    formatePlans() {
      return this.registerForm.form.plans.map(plan => {
        return {
          ...plan,
          tariffPlan: plan.tariffPlan._id,
        };
      });
    },
    async createPark() {
      if (!this.permissionCreate) {
        return;
      }
      this.registerForm.control.createButtonIsDisabled = true;

      const payload = {
        ...this.registerForm.form,
      };

      try {
        await this.$store.dispatch('PARKING/CreatePark', payload);

        this.disableEditMode();
        this.ListParks();

        this.$toasted.success('Estacionamento castrada com sucesso');
      } catch (error) {
        this.$toasted.error('Não foi possível criar a Estacionamento');
      } finally {
        this.registerForm.control.createButtonIsDisabled = false;
      }
    },
    enterEditMode(park) {
      this.registerForm.control.editModeId = park._id;
      this.registerForm.form.parkName = park.parkName;
      this.registerForm.form.internalName = park.internalName;
      this.registerForm.form.internalCode = park.internalCode;
      this.registerForm.form.parkingSpaceCount = park.parkingSpaceCount;
      this.registerForm.form.continuousTolerance =
        park.continuousTolerance || 0;
      this.registerForm.form.disabled = park.disabled;
      this.registerForm.form.street = park.address && park.address.street || '';
      this.registerForm.form.neighborhood = park.address && park.address.neighborhood || '';
      this.registerForm.form.uf = park.address && park.address.uf || '';
      this.registerForm.form.disabled = park.disabled;
      this.registerForm.form.spots = park.spots.map(spot => {
        return {
          ...spot,
          location: spot.location && {
            lat: spot.location.coordinates[0],
            lng: spot.location.coordinates[1],
          },
        };
      });
      this.registerForm.form.geoReference = park.geoReference
        ? park.geoReference.coordinates.map(coord => {
            return {
              lat: coord[0],
              lng: coord[1],
            };
          })
        : [];
      this.registerForm.form.pathPolygon = {
        lat: park.pathPolygon.coordinates[0],
        lng: park.pathPolygon.coordinates[1],
      };
    },
    disableEditMode() {
      this.registerForm.control.editModeId = false;
      this.registerForm.form.parkName = '';
      this.registerForm.form.internalName = '';
      this.registerForm.form.internalCode = '';
      this.registerForm.form.parkingSpaceCount = '';
      this.registerForm.form.continuousTolerance = '';
      this.registerForm.form.disabled = '';
      this.registerForm.form.street = '';
      this.registerForm.form.neighborhood = '';
      this.registerForm.form.uf = '';
      this.registerForm.form.geoReference = [];
      this.registerForm.form.spots = [];
      this.registerForm.form.pathPolygon = {
        lat: '',
        lng: '',
      };
    },
    async saveEdition() {
      this.registerForm.control.createButtonIsDisabled = true;

      const id = this.registerForm.control.editModeId;
      const payload = {
        parkId: id,
        ...this.registerForm.form,
      };
      try {
        await this.$store.dispatch(
          'PARKING/UpdatePark',

          payload,
        );
        this.ListParks();

        this.disableEditMode();
        this.$toasted.success('Estacionamento salva com sucesso');
      } catch (error) {
        this.$toasted.error(error.error);
      } finally {
        this.registerForm.control.createButtonIsDisabled = false;
      }
    },
  },
};
</script>
